import {
  GET_OUTLETS,
  SEARCH_OUTLETS,
  GET_OUTLETS_PAGINATED,
  GET_OUTLET_DETAILS_BY_USER_ID,
  GET_OUTLET_DETAILS_BY_OUTLET_ID,
  GET_OUTLET_TAGS,
  GET_OUTLET_ATTRIBUTES,
  DEACTIVATE_OUTLET,
  SUCCESS,
  FAIL,
} from "../action_types";

const STATE_INIT = {
  isLoading: false,
  isUpdating: false,
  outlets: [],
  // Paginated state (for OutletsManagement)
  paginatedOutlets: [],
  totalItems: 0,
  totalPages: 1,
  currentPage: 1,
  filterOptions: { cities: [], counties: [] },
  outletDetails: [],
  outletDetailsById: [],
  outletTags: {},
  outletAttributes: {},
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    // Original getOutlets - returns all outlets (for dropdowns)
    case GET_OUTLETS:
      return { ...state, isLoading: true };
    case `${GET_OUTLETS}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        outlets: payload.outlets || [],
      };
    case `${GET_OUTLETS}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case SEARCH_OUTLETS:
      return { ...state, isLoading: true };
    case `${SEARCH_OUTLETS}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        outlets: [...payload],
      };
    case `${SEARCH_OUTLETS}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };
    // Paginated getOutletsPaginated - for OutletsManagement page
    case GET_OUTLETS_PAGINATED:
      return { ...state, isLoading: true };
    case `${GET_OUTLETS_PAGINATED}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        paginatedOutlets: payload.outlets || [],
        totalItems: payload.totalItems || 0,
        totalPages: payload.totalPages || 1,
        currentPage: payload.currentPage || 1,
        filterOptions: payload.filterOptions || { cities: [], counties: [] },
      };
    case `${GET_OUTLETS_PAGINATED}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case DEACTIVATE_OUTLET:
      return { ...state, isUpdating: true };
    case `${DEACTIVATE_OUTLET}_${SUCCESS}`:
      return { ...state, isUpdating: false };
    case `${DEACTIVATE_OUTLET}_${FAIL}`:
      return { ...state, isUpdating: false, error: { ...payload } };

    case GET_OUTLET_DETAILS_BY_USER_ID:
      return { ...state, isLoading: true };
    case `${GET_OUTLET_DETAILS_BY_USER_ID}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        outletDetails: [...payload],
      };
    case `${GET_OUTLET_DETAILS_BY_USER_ID}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case GET_OUTLET_DETAILS_BY_OUTLET_ID:
      return { ...state, isLoading: true };
    case `${GET_OUTLET_DETAILS_BY_OUTLET_ID}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        outletDetailsById: [...payload],
      };
    case `${GET_OUTLET_DETAILS_BY_OUTLET_ID}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case GET_OUTLET_TAGS:
      return { ...state };
    case `${GET_OUTLET_TAGS}_${SUCCESS}`: {
      const { outletId, tags } = payload;
      const updatedOutletDetails = state.outletDetailsById.map((outlet) => {
        if (outlet.outletId === outletId || outlet.id === outletId) {
          return { ...outlet, tags };
        }
        return outlet;
      });
      return {
        ...state,
        outletTags: {
          ...state.outletTags,
          [outletId]: tags,
        },
        outletDetailsById: updatedOutletDetails.length > 0 ? updatedOutletDetails : state.outletDetailsById,
      };
    }
    case `${GET_OUTLET_TAGS}_${FAIL}`:
      return { ...state, error: { ...payload } };

    case GET_OUTLET_ATTRIBUTES:
      return { ...state };
    case `${GET_OUTLET_ATTRIBUTES}_${SUCCESS}`: {
      const { outletId, attributes } = payload;
      return {
        ...state,
        outletAttributes: {
          ...state.outletAttributes,
          [outletId]: attributes,
        },
      };
    }
    case `${GET_OUTLET_ATTRIBUTES}_${FAIL}`:
      return { ...state, error: { ...payload } };

    default:
      return state;
  }
};
